module.exports = __webpack_public_path__ + "media/images/doemeraldcoast-title-dark-a21ceb815e002fb5ac624c679df877ac.png";